import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { X } from 'react-bootstrap-icons';
import StartSession from '../../../../Base/components/NavBar/components/SessionInfo/components/StartSession/StartSession';
import '../../../../../styles/Forms.scss';

interface LocalClosedModalProps {
    show: boolean;
    redir: number;
}

const LocalClosedModal: React.FC<LocalClosedModalProps> = ({ show, redir }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (redir === 201) {
            navigate('/App/CajasManagement')
        } else if (redir === 500) {
            navigate('/App')
        }
    }

    // If the redirect code indicates the local is closed, render the StartSession modal
    if (redir === 202) {
        return (
            <StartSession show={show} handleClose={() => navigate('/App')} />
        );
    }

    return (
        <Modal show={show} centered>
            <Modal.Header>
                <div className="form-modal-title-container">
                    <Modal.Title className="form-modal-title">
                        {redir === 201 && 'No hay cajas abiertas'}
                        {redir === 202 && 'Local cerrado'}
                        {redir === 500 && 'Error'}
                    </Modal.Title>
                </div>
                <Button variant="none" className="modal-close-button" onClick={() => navigate('/App')}>
                    <X size={20} />
                </Button>
            </Modal.Header>
            <Modal.Body>
                <p style={{ color: 'var(--text-color)', margin: 0 }}>
                    {redir === 201 && 'El local no tiene ninguna caja abierta. No se pueden tomar pedidos hasta que haya al menos una caja abierta.'}
                    {redir === 202 && 'El local se encuentra cerrado. No se pueden tomar pedidos hasta iniciar sesión.'}
                    {redir === 500 && 'Error inesperado. Por favor, intente nuevamente.'}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-modal-footer-custom">
                    <Button className="form-button-create" variant="none" onClick={handleNavigate}>
                        {redir === 201 && 'Ir a Cajas'}
                        {redir === 202 && 'Ir a iniciar sesión'}
                        {redir === 500 && 'Ir a inicio'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default LocalClosedModal;